import React from 'react';
import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';
import { useTheme } from '../context/ThemeContext.jsx';

const PrivacyPolicy = () => {
  const { 
    colors, 
    spacing, 
    fonts,
    borderRadius,
    shadows
  } = useTheme();

  const pageStyles = {
    minHeight: '100vh',
    backgroundColor: colors.background,
    color: colors.text,
    fontFamily: fonts.families.primary,
    lineHeight: fonts.lineHeights.relaxed,
    transition: 'all 0.3s ease'
  };

  const mainStyles = {
    maxWidth: '900px',
    margin: `${spacing.scale['2xl']} auto`,
    padding: `0 ${spacing.scale.lg}`
  };

  const contentContainerStyles = {
    backgroundColor: colors.surface,
    borderRadius: borderRadius.xl,
    boxShadow: shadows.xl,
    overflow: 'hidden',
    border: `1px solid ${colors.border}`
  };

  const headerSectionStyles = {
    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryHover} 100%)`,
    color: colors.textInverse,
    padding: `${spacing.scale.lg} ${spacing.scale.md}`, // Even smaller padding
    textAlign: 'center'
  };

  const titleStyles = {
    fontSize: fonts.sizes.xl.desktop, // Even smaller title
    marginBottom: spacing.scale.sm, // Minimal margin
    fontWeight: fonts.weights.bold,
    fontFamily: fonts.families.secondary,
    color: '#ffffff', // Force white text
    textShadow: `1px 1px 2px rgba(0, 0, 0, 0.5)` // Add shadow for visibility
  };

  const updatedStyles = {
    fontSize: fonts.sizes.sm.desktop,
    opacity: 0.95,
    backgroundColor: `${colors.info}33`,
    padding: `${spacing.scale.xs} ${spacing.scale.md}`, // Smaller padding
    borderRadius: borderRadius.full,
    display: 'inline-block',
    border: `1px solid ${colors.info}66`,
    color: '#ffffff', // Force white text
    marginBottom: spacing.scale.xs // Minimal margin
  };

  const contentStyles = {
    padding: `${spacing.scale.lg} ${spacing.scale.xl}` // Much smaller top padding
  };

  const sectionStyles = {
    marginBottom: spacing.scale['3xl']
  };

  const sectionHeadingStyles = {
    color: colors.text,
    fontSize: fonts.sizes['2xl'].desktop,
    marginBottom: spacing.scale.xl,
    paddingBottom: spacing.scale.sm,
    borderBottom: `2px solid ${colors.border}`,
    fontFamily: fonts.families.secondary,
    fontWeight: fonts.weights.semibold
  };

  const paragraphStyles = {
    marginBottom: spacing.scale.xl,
    fontSize: fonts.sizes.base.desktop,
    color: colors.text,
    lineHeight: fonts.lineHeights.relaxed
  };

  const highlightBoxStyles = {
    backgroundColor: `${colors.info}15`, // 8% opacity
    border: `1px solid ${colors.info}`,
    borderRadius: borderRadius.md,
    padding: spacing.scale.xl,
    margin: `${spacing.scale.xl} 0`
  };

  const tocStyles = {
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.lg,
    padding: spacing.scale.xl,
    marginBottom: spacing.scale['3xl'],
    borderLeft: `4px solid ${colors.secondary}`,
    border: `1px solid ${colors.border}`
  };

  const tocTitleStyles = {
    marginBottom: spacing.scale.lg,
    color: colors.text,
    fontSize: fonts.sizes.xl.desktop,
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.families.secondary
  };

  const tocLinkStyles = {
    color: colors.secondary,
    textDecoration: 'none',
    transition: 'color 0.3s ease'
  };

  const highlightTitleStyles = {
    color: colors.info,
    marginTop: 0,
    marginBottom: spacing.scale.md,
    fontSize: fonts.sizes.lg.desktop,
    fontWeight: fonts.weights.semibold
  };

  const subHeadingStyles = {
    color: colors.textSecondary,
    fontSize: fonts.sizes.xl.desktop,
    margin: `${spacing.scale.xl} 0 ${spacing.scale.lg} 0`,
    fontWeight: fonts.weights.medium
  };

  const listStyles = {
    marginBottom: spacing.scale.xl,
    paddingLeft: spacing.scale.xl,
    color: colors.text
  };

  const listItemStyles = {
    marginBottom: spacing.scale.md
  };

  const contactInfoStyles = {
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.lg,
    padding: spacing.scale.xl,
    marginTop: spacing.scale['3xl'],
    textAlign: 'center',
    border: `1px solid ${colors.border}`
  };

  const contactTitleStyles = {
    color: colors.text,
    marginBottom: spacing.scale.lg,
    fontSize: fonts.sizes.xl.desktop,
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.families.secondary
  };

  const contactLinkStyles = {
    color: colors.secondary,
    textDecoration: 'none',
    fontWeight: fonts.weights.medium,
    transition: 'color 0.3s ease'
  };

  const handleLinkHover = (e) => {
    e.target.style.color = colors.secondaryHover;
  };

  const handleTocLinkHover = (e) => {
    e.target.style.color = colors.secondaryHover;
  };

  const handleTocLinkLeave = (e) => {
    e.target.style.color = colors.secondary;
  };

  const handleContactLinkHover = (e) => {
    e.target.style.color = colors.secondaryHover;
  };

  const handleContactLinkLeave = (e) => {
    e.target.style.color = colors.secondary;
  };

  return (
    <div style={pageStyles}>
      <Header showBreadcrumb={false} />
      
      <main style={mainStyles}>
        <div style={contentContainerStyles}>
          <section style={headerSectionStyles}>
            <h1 style={titleStyles}>Privacy Policy</h1>
            <div style={updatedStyles}>Last Updated: July 16, 2026</div>
            {/* <div style={{ marginTop: spacing.scale.xs }}>
              <DocumentDownload 
                document={{
                  name: "Privacy Policy",
                  filename: "privacy-policy",
                  type: "privacy"
                }}
              />
            </div> */}
            <div style={{ marginTop: spacing.scale.xs, display: 'flex', justifyContent: 'center' }}>
              <button
                onClick={() => window.print()}
                style={{
                  backgroundColor: colors.secondary,
                  color: colors.textOnAccent,
                  border: 'none',
                  padding: `${spacing.scale.sm} ${spacing.scale.lg}`,
                  borderRadius: borderRadius.md,
                  fontSize: fonts.sizes.sm.desktop,
                  fontWeight: fonts.weights.medium,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: spacing.scale.xs
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.secondaryHover;
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = colors.secondary;
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                🖨️ Print Document
              </button>
            </div>
          </section>

          <div style={contentStyles}>
            <section style={tocStyles}>
              <h2 style={tocTitleStyles}>Table of Contents</h2>
              <ol style={{ paddingLeft: spacing.scale.xl }}>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#information-collection" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Information We Collect</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#information-use" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>How We Use Your Information</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#information-sharing" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Information Sharing and Disclosure</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#data-security" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Data Security</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#cookies" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Cookies and Tracking Technologies</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#your-rights" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Your Rights and Choices</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#data-retention" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Data Retention</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#international-transfers" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>International Data Transfers</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#children-privacy" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Children's Privacy</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#updates" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Updates to This Policy</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#contact" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Contact Information</a>
                </li>
              </ol>
            </section>

            <div style={highlightBoxStyles}>
              <h3 style={highlightTitleStyles}>Your Privacy Matters</h3>
              <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                At LondaLab, we are committed to protecting your privacy and ensuring transparency about how we collect, use, and protect your personal information. This Privacy Policy explains our practices in clear, understandable terms.
              </p>
            </div>

            <section style={sectionStyles} id="information-collection">
              <h2 style={sectionHeadingStyles}>1. Information We Collect</h2>
              
              <h3 style={subHeadingStyles}>Information You Provide Directly</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Contact Information:</strong> Name, email address, phone number, mailing address</li>
                <li style={listItemStyles}><strong>Account Information:</strong> Username, password, profile details</li>
                <li style={listItemStyles}><strong>Communication Records:</strong> Messages sent through our contact forms, chat widget, or email</li>
                <li style={listItemStyles}><strong>Purchase Information:</strong> Order details and billing address (payment details handled by Stripe)</li>
                <li style={listItemStyles}><strong>Support Requests:</strong> Technical issues, questions, feedback</li>
              </ul>

              <h3 style={subHeadingStyles}>Information Collected Automatically</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Usage Data:</strong> Pages visited, time spent on site, click patterns, referral sources</li>
                <li style={listItemStyles}><strong>Device Information:</strong> IP address, browser type, operating system, device identifiers</li>
                <li style={listItemStyles}><strong>Performance Data:</strong> Site loading times, error reports, feature usage statistics</li>
                <li style={listItemStyles}><strong>Location Data:</strong> General geographic location based on IP address</li>
              </ul>

              <h3 style={subHeadingStyles}>Information from Third Parties</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Payment Processors:</strong> Transaction information from secure payment providers</li>
                <li style={listItemStyles}><strong>Analytics Services:</strong> Website usage data from analytics platforms</li>
                <li style={listItemStyles}><strong>Social Media:</strong> Public profile information if you connect social accounts</li>
              </ul>
            </section>

            <section style={sectionStyles} id="information-use">
              <h2 style={sectionHeadingStyles}>2. How We Use Your Information</h2>
              
              <h3 style={subHeadingStyles}>Primary Uses</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Product Delivery:</strong> Providing our apps, credits, and digital content</li>
                <li style={listItemStyles}><strong>Account Management:</strong> Creating and maintaining user accounts</li>
                <li style={listItemStyles}><strong>Communication:</strong> Responding to inquiries and providing updates</li>
                <li style={listItemStyles}><strong>Order Processing:</strong> Managing purchases and subscriptions (payments handled by Stripe)</li>
                <li style={listItemStyles}><strong>Customer Support:</strong> Troubleshooting issues and providing assistance</li>
              </ul>

              <h3 style={subHeadingStyles}>Secondary Uses (with consent)</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Marketing:</strong> Sending newsletters, product updates, and promotional content</li>
                <li style={listItemStyles}><strong>Analytics:</strong> Understanding user behavior to improve our products and services</li>
                <li style={listItemStyles}><strong>Personalization:</strong> Customizing content and recommendations based on your interests</li>
                <li style={listItemStyles}><strong>Product Development:</strong> Developing new features and improving existing offerings</li>
              </ul>
            </section>

            <section style={sectionStyles} id="information-sharing">
              <h2 style={sectionHeadingStyles}>3. Information Sharing and Disclosure</h2>
              
              <p style={paragraphStyles}>We do not sell, rent, or trade your personal information. We may share your information only in the following circumstances:</p>

              <h3 style={subHeadingStyles}>Service Providers</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Payment Processing:</strong> Stripe securely handles all payment information</li>
                <li style={listItemStyles}><strong>Cloud Hosting:</strong> AWS, Microsoft Azure for website and data hosting</li>
                <li style={listItemStyles}><strong>Communication:</strong> Email service providers, SMS service providers</li>
                <li style={listItemStyles}><strong>Analytics:</strong> Website analytics and performance monitoring services</li>
              </ul>

              <h3 style={subHeadingStyles}>Legal Requirements</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}>Compliance with legal obligations, court orders, or government requests</li>
                <li style={listItemStyles}>Protection of our rights, property, or safety, or that of others</li>
                <li style={listItemStyles}>Investigation of potential violations of our terms of service</li>
                <li style={listItemStyles}>Prevention of fraud or illegal activities</li>
              </ul>

              <h3 style={subHeadingStyles}>Business Transfers</h3>
              <p style={paragraphStyles}>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the business transaction, with the same privacy protections applied.</p>
            </section>

            <section style={sectionStyles} id="data-security">
              <h2 style={sectionHeadingStyles}>4. Data Security</h2>
              
              <p style={paragraphStyles}>We implement industry-standard security measures to protect your personal information:</p>

              <h3 style={subHeadingStyles}>Technical Safeguards</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Encryption:</strong> All data transmitted to and from our servers is encrypted using TLS 1.3</li>
                <li style={listItemStyles}><strong>Access Controls:</strong> Role-based access with multi-factor authentication</li>
                <li style={listItemStyles}><strong>Data Backup:</strong> Regular, encrypted backups with geographic redundancy</li>
                <li style={listItemStyles}><strong>Monitoring:</strong> Continuous security monitoring and incident response procedures</li>
              </ul>

              <h3 style={subHeadingStyles}>Administrative Safeguards</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}>Employee training on data protection and privacy practices</li>
                <li style={listItemStyles}>Regular security audits and vulnerability assessments</li>
                <li style={listItemStyles}>Incident response procedures and breach notification protocols</li>
                <li style={listItemStyles}>Vendor security assessments and contractual obligations</li>
              </ul>
            </section>

            <section style={sectionStyles} id="cookies">
              <h2 style={sectionHeadingStyles}>5. Cookies and Tracking Technologies</h2>
              
              <h3 style={subHeadingStyles}>Types of Cookies We Use</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Essential Cookies:</strong> Required for website functionality and security</li>
                <li style={listItemStyles}><strong>Analytics Cookies:</strong> Help us understand how visitors use our website</li>
                <li style={listItemStyles}><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
                <li style={listItemStyles}><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements (with consent)</li>
              </ul>

              <h3 style={subHeadingStyles}>Managing Cookies</h3>
              <p style={paragraphStyles}>You can control cookies through your browser settings or our cookie consent banner. Disabling certain cookies may affect website functionality.</p>

              <div style={highlightBoxStyles}>
                <h3 style={highlightTitleStyles}>Cookie Consent</h3>
                <p style={{ ...paragraphStyles, marginBottom: 0 }}>We respect your choice regarding cookies. You can accept or reject non-essential cookies through our consent banner, and change your preferences at any time.</p>
              </div>
            </section>

            <section style={sectionStyles} id="your-rights">
              <h2 style={sectionHeadingStyles}>6. Your Rights and Choices</h2>
              
              <p style={paragraphStyles}>You have the following rights regarding your personal information:</p>

              <h3 style={subHeadingStyles}>Access and Portability</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Access:</strong> Request a copy of your personal information we hold</li>
                <li style={listItemStyles}><strong>Portability:</strong> Receive your data in a structured, machine-readable format</li>
                <li style={listItemStyles}><strong>Transparency:</strong> Understand how your data is being used</li>
              </ul>

              <h3 style={subHeadingStyles}>Correction and Deletion</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Correction:</strong> Update or correct inaccurate information</li>
                <li style={listItemStyles}><strong>Deletion:</strong> Request deletion of your personal information</li>
                <li style={listItemStyles}><strong>Restriction:</strong> Limit how we process your information</li>
              </ul>

              <h3 style={subHeadingStyles}>Marketing and Communication</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Opt-out:</strong> Unsubscribe from marketing communications at any time</li>
                <li style={listItemStyles}><strong>Preferences:</strong> Choose what types of communications you receive</li>
                <li style={listItemStyles}><strong>Frequency:</strong> Adjust how often you hear from us</li>
              </ul>
            </section>

            <section style={sectionStyles} id="data-retention">
              <h2 style={sectionHeadingStyles}>7. Data Retention</h2>
              
              <p style={paragraphStyles}>We retain personal information only as long as necessary for the purposes outlined in this policy:</p>

              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Active Customers:</strong> Throughout the business relationship and for 7 years after for legal and tax purposes</li>
                <li style={listItemStyles}><strong>Prospects:</strong> Up to 3 years unless you opt-out of communications</li>
                <li style={listItemStyles}><strong>Website Visitors:</strong> Analytics data retained for 14 months</li>
                <li style={listItemStyles}><strong>Marketing Data:</strong> Until you unsubscribe or 5 years of inactivity</li>
                <li style={listItemStyles}><strong>Legal Requirements:</strong> As required by applicable laws and regulations</li>
              </ul>
            </section>

            <section style={sectionStyles} id="international-transfers">
              <h2 style={sectionHeadingStyles}>8. International Data Transfers</h2>
              
              <p style={paragraphStyles}>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place:</p>

              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Adequacy Decisions:</strong> Transfers to countries with adequate data protection laws</li>
                <li style={listItemStyles}><strong>Standard Contractual Clauses:</strong> EU-approved contracts for international transfers</li>
                <li style={listItemStyles}><strong>Certification Programs:</strong> Partners certified under recognized privacy frameworks</li>
                <li style={listItemStyles}><strong>Binding Corporate Rules:</strong> Internal policies ensuring consistent protection standards</li>
              </ul>
            </section>

            <section style={sectionStyles} id="children-privacy">
              <h2 style={sectionHeadingStyles}>9. Children's Privacy</h2>
              
              <p style={paragraphStyles}>Our services are intended for businesses and individuals 18 years or older. We do not knowingly collect personal information from children under 18. If we become aware that we have collected information from a child under 18, we will take steps to delete such information promptly.</p>

              <p style={paragraphStyles}>If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
            </section>

            <section style={sectionStyles} id="updates">
              <h2 style={sectionHeadingStyles}>10. Updates to This Policy</h2>
              
              <p style={paragraphStyles}>We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or legal requirements. We will:</p>

              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Notify You:</strong> Provide advance notice of material changes via email or website notice</li>
                <li style={listItemStyles}><strong>Post Updates:</strong> Display the updated policy with the revision date</li>
                <li style={listItemStyles}><strong>Maintain Archives:</strong> Keep previous versions available upon request</li>
                <li style={listItemStyles}><strong>Seek Consent:</strong> Obtain new consent for expanded uses of existing data</li>
              </ul>
            </section>

            <section style={sectionStyles} id="contact">
              <h2 style={sectionHeadingStyles}>11. Contact Information</h2>
              
              <div style={contactInfoStyles}>
                <h3 style={contactTitleStyles}>Data Protection Contact</h3>
                <p style={paragraphStyles}>For questions about this Privacy Policy or to exercise your privacy rights:</p>
                <p style={paragraphStyles}>
                  <strong>General Questions:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleContactLinkHover}
                    onMouseLeave={handleContactLinkLeave}
                  >hello@londalab.com</a><br />
                  <strong>Legal/Privacy Questions:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleContactLinkHover}
                    onMouseLeave={handleContactLinkLeave}
                  >hello@londalab.com</a><br />
                  <strong>Report Criminal Activity:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleContactLinkHover}
                    onMouseLeave={handleContactLinkLeave}
                  >hello@londalab.com</a>
                </p>
                <p style={paragraphStyles}>
                  <strong>LondaLab</strong>, a Victoria Londe brand<br />
                  2883 Hopyard Rd<br />
                  Pleasanton, CA 94588
                </p>
                <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                  <strong>Response Time:</strong> We typically respond within 3-5 business days.
                </p>
              </div>
            </section>

            <div style={highlightBoxStyles}>
              <h3 style={highlightTitleStyles}>Questions or Concerns?</h3>
              <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                If you have any questions about this Privacy Policy or our privacy practices, please don't hesitate to contact us. We're committed to addressing your concerns and maintaining your trust.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;